import _jsx from "@babel/runtime/helpers/jsx";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _Icon;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { stringify } from 'query-string';
import Icon from 'components/Icon';
import messages from './messages';
import { CheckboxContainer, StyledCheckbox, HiddenCheckbox, CheckboxWrapper, CheckboxText } from './styles';

function FilterCheckboxItem(_ref) {
  var item = _ref.item,
      block = _ref.block,
      checked = _ref.checked,
      searchParams = _ref.searchParams;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var history = useHistory();
  var handleCheckboxChange = useCallback(function (e) {
    var _searchParams$block;

    var newLocationSearchObj = e.target.checked ? _objectSpread(_objectSpread({}, searchParams), {}, _defineProperty({}, block, ((_searchParams$block = searchParams[block]) == null ? void 0 : _searchParams$block.length) > 0 ? [].concat(_toConsumableArray(searchParams[block]), [item]) : [item])) : _objectSpread(_objectSpread({}, searchParams), {}, _defineProperty({}, block, searchParams[block].filter(function (el) {
      return el !== item;
    })));
    history.push({
      search: stringify(newLocationSearchObj, {
        arrayFormat: 'comma'
      })
    });
  }, [searchParams]);
  return /*#__PURE__*/_jsx(CheckboxWrapper, {}, void 0, /*#__PURE__*/_jsx(CheckboxContainer, {}, void 0, /*#__PURE__*/_jsx(HiddenCheckbox, {
    checked: checked,
    onChange: handleCheckboxChange
  }), /*#__PURE__*/_jsx(StyledCheckbox, {
    checked: checked
  }, void 0, _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
    name: "checked"
  })))), /*#__PURE__*/_jsx(CheckboxText, {}, void 0, formatMessage(messages[item])));
}

export default /*#__PURE__*/memo(FilterCheckboxItem);